<template>
  <div>
    <van-cell class="ry-form__sliding-block" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div class="ry-form__sliding-block-body">
          <van-slider
            v-model="current.value"
            :disabled="isReadOnly || isRead"
            :max="current.maxValue"
            :min="current.minValue"
            :step="current.step"
			active-color="#32D071"
            @change="controlChange">
            <div
              slot="button"
              class="custom-button">
              {{ current.value }}
            </div>
          </van-slider>
          <van-field
            v-if="!isRead && !!current.manuallyEnter"
            class="step-input"
            type="number"
            :readonly="isReadOnly"
            @change="controlChange"
            :formatter="formatter"
            placeholder="请输入"
            v-model="current.value">
          </van-field>
        </div>
      </template>
    </van-cell>


    <div v-else class="ry-form-item-compact ry-form__sliding-block-compact">
      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div class="ry-form__sliding-block-body">
            <van-slider
              v-model="current.value"
              :disabled="isReadOnly || isRead"
              :max="current.maxValue"
              :min="current.minValue"
              :step="current.step"
			  active-color="#32D071"
              @change="controlChange">
              <div
                slot="button"
                class="custom-button">
                {{ current.value }}
              </div>
            </van-slider>
            <van-field
              class="step-input"
              v-if="!isRead && !!current.manuallyEnter"
              type="number"
              :readonly="isReadOnly"
              @change="controlChange"
              :formatter="formatter"
              placeholder="请输入"
              v-model="current.value">
            </van-field>
          </div>
        </template>
      </van-field>
    </div>
  </div>
</template>

<script>
  import { current } from './mixin'

  export default {
    mixins: [current],
    data() {
      return {
      }
    },
    methods: {
      formatter(val) {
        val = Number(val)
        if (val) {
          if (val > this.current.maxValue) {
            val = this.current.maxValue
          } else if (val < this.current.minValue) {
            val = this.current.minValue
          } else {
            val = Number(val)
          }
        } else {
          val = this.current.minValue
        }
        return val
      }
    }
  }
</script>
